var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { attrs: { id: "wrap" } },
      [
        _c("skp-gnb", {
          on: {
            "router-reload": function($event) {
              return _vm.routerReload()
            }
          }
        }),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c(
            "div",
            { staticClass: "container_wrap" },
            [
              _c("keep-alive", [_c("admin-snb")], 1),
              _vm._v(" "),
              _c("router-view", { key: _vm.$route.fullPath })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("keep-alive", [_c("skp-footer")], 1)
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "goto_top" }, [
      _c(
        "a",
        { staticClass: "scroll_top_btn", attrs: { href: "javascript:" } },
        [_c("span", { staticClass: "sr_only" }, [_vm._v("TOP")])]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f5ce98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f5ce98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/AdminMain.vue
// module id = 1/ii
// module chunks = 0